export enum SearchType {
  CUSTOM_SEARCH = 'Custom search',
  SEARCH = 'Search'
}
